import { tv } from 'tailwind-variants'
import Image from 'next/image'
import * as Arcade from '../types'
import { Icon } from '@/components'
import { numberWithCommas } from '@/util/numberHelpers'
import { determineRank, rankToBadge } from '@/features/arcade/utils'
import { arcadeBadgeIcon } from '@/features/arcade/constants'
import { ARCADE_BADGE_TYPES } from '@/enum'

const rankStyles = tv({
  base: 'relative grid grid-cols-[subgrid] items-center col-span-full text-sm text-gray-300 p-1 body-sm',
  variants: {
    active: {
      true: 'text-white rounded-[12px] bg-gray-800'
    }
  }
})

const iconStyles = tv({
  base: 'w-[14px] h-[14px] text-gray-300',
  variants: {
    eligible: {
      true: 'text-arcadeGreen'
    }
  }
})

export const PlayerRanking = ({
  playerRanking,
  rankThreshold
}: {
  playerRanking: Arcade.MiniPlayerRank
  rankThreshold: number
}) => {
  const active = playerRanking.current_player
  const rankCss = rankStyles({ active })
  const avatarUrl = playerRanking.media.avatar_media?.size0_url ?? ''

  const badgeEligibility =
    rankToBadge[determineRank(playerRanking.rank, rankThreshold)]

  const icon = arcadeBadgeIcon(badgeEligibility)
  const isEligible = badgeEligibility === ARCADE_BADGE_TYPES.Eligible

  return (
    <div className={rankCss}>
      <div className="flex items-center">
        <Icon name={icon} className={iconStyles({ eligible: isEligible })} />
        <div className="ml-[4px] min-w-[25px] overflow-hidden leading-tight h-[14px]">
          {numberWithCommas(playerRanking.rank)}
        </div>
      </div>
      <div className="ml-[9px] flex items-center">
        <Image
          className="rounded-[6px]"
          src={avatarUrl}
          alt={playerRanking.account}
          width={20}
          height={20}
        />
        <div className="ml-[9px] overflow-hidden whitespace-nowrap text-ellipsis md:max-w-[77px]">
          {playerRanking.account}
        </div>
      </div>
      <div className="ml-auto flex gap-[4px] pl-1 items-center">
        <Icon name="arcade" className="w-[14px] h-[14px]" />
        <div className="overflow-hidden leading-tight h-[14px]">
          {numberWithCommas(playerRanking.points)}
        </div>
      </div>
    </div>
  )
}
